import { render, staticRenderFns } from "./Medication.vue?vue&type=template&id=704fe98a&scoped=true"
import script from "./Medication.vue?vue&type=script&lang=js"
export * from "./Medication.vue?vue&type=script&lang=js"
import style0 from "./Medication.vue?vue&type=style&index=0&id=704fe98a&prod&lang=scss"
import style1 from "./Medication.vue?vue&type=style&index=1&id=704fe98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704fe98a",
  null
  
)

export default component.exports